import { createApi, fetchBaseQuery } from '@reduxjs/toolkit/query/react';

const menuRTK = createApi({
    baseQuery: fetchBaseQuery({ baseUrl: process.env.REACT_APP_BASE_URL }),
    reducerPath: 'headerMenu',
    keepUnusedDataFor: 300,
    fetchFn: (...args) => {
        console.log('RTK Fetch:', args);
        return fetch(...args);
    },
    endpoints: (builder) => ({
        fetchMenu: builder.query({
            query: () => '/get-header-link?nested'
        })
    })
});


export default menuRTK;
export const { useFetchMenuQuery } = menuRTK;